module.exports = __webpack_public_path__ + "img/CLVHelp2.f8d94447.png";